import { deleteRatesZoneRequest } from "../../data/ratesZoneApi";

export async function deleteTarifaZoneUseCase(id) {
  if (!id) {
    throw new Error("El id de la tarifa de zona es obligatorio.");
  }

  return await deleteRatesZoneRequest(id);
}
